import {useDispatch,useSelector} from 'react-redux'
import {
	fetchMerchandiseOrders,
	fetchMerchandiseItems,
	selectMerchandiseById,
	selectAllMerchandise,
	selectMerchandiseIds,
	selectItemsByIds,
	selectOrderById,
	selectAllOrders,
	selectOrderIds,
	selectEditor,
	selectCart
} from './slice'

export const useMerchandiseItems = ()=>{
	const dispatch = useDispatch()
	const status = useSelector(state=>state.merchandise.items.status)
	const merchandise = useSelector(selectAllMerchandise)
	const ids = useSelector(selectMerchandiseIds)
	if(status === 'init'){
		dispatch(fetchMerchandiseItems())
	}

	return {status,merchandise,ids}
}

export const useMerchandiseItem = id => {

	const dispatch = useDispatch()
	const status = useSelector(state=>state.merchandise.items.status)
	const item = useSelector(state=>selectMerchandiseById(state,id))

	if(status === 'init') dispatch(fetchMerchandiseItems())

	return {status,item}
}

export const useMerchandiseOrders = ()=>{
	const dispatch = useDispatch()
	const status = useSelector(state=>state.merchandise.orders.status)
	const orders = useSelector(selectAllOrders)
	const ids = useSelector(selectOrderIds)
	if(status === 'init'){
		dispatch(fetchMerchandiseOrders())
	}

	return {status,orders,ids}
}

export const useMerchandiseOrder = id => {

	const dispatch = useDispatch()
	const status = useSelector(state=>state.merchandise.orders.status)
	const order = useSelector(state=>selectOrderById(state,id))

	if(status === 'init') dispatch(fetchMerchandiseOrders())

	return {status,order}
}

export const useMerchandiseEditor = ()=>{
	return useSelector(selectEditor)
}

export const useCart = ()=>{
	const {itemsQtyMap} = useSelector(selectCart)
	const ids = Object.keys(itemsQtyMap)
	const hasItems = ids.length > 0
	const items = useSelector(state=>selectItemsByIds(state,ids))
	const total = (items.reduce((carry,item)=>(
		carry + item.unit_amount*itemsQtyMap[item.id]
	),0)/100).toFixed(2)
	return {itemsQtyMap,hasItems,total}
}